import { render, staticRenderFns } from "./BprWarningModal.vue?vue&type=template&id=0733ead4"
import script from "./BprWarningModal.vue?vue&type=script&lang=ts"
export * from "./BprWarningModal.vue?vue&type=script&lang=ts"
import style0 from "./BprWarningModal.vue?vue&type=style&index=0&id=0733ead4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports